<template>
  <div class="flex gap-x-[12px]">
    <div
      v-for="format in formats"
      :key="format.id"
      class="flex gap-x-[4px] text-14 cursor-pointer hover:text-font-1 hover:font-medium"
      :class="[resolution === format.key ? 'text-font-1 font-medium' : 'text-font-60']"
      @click="handleClick(format.key)"
    >
      <iconpark-icon :name="`screen-${format.id}`" size="18" />
      {{ format.label }}
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * iconpark 上的名称要严格跟数据的 id 匹配
 */
const formats = useDicts('formats');

const resolution = defineModel<string>('resolution', { default: undefined });

const emit = defineEmits(['change']);

function handleClick($resolution: string | number) {
  const val = `${$resolution}`;
  resolution.value = val;
  emit('change', val);
}
</script>
